import { useState, useEffect } from 'react';
import type { OrderSummaryData } from '../../../types';

export const useCouponManagement = (
  summary: OrderSummaryData,
  onApplyCoupon: (couponCode: string) => Promise<void>
) => {
  const [couponInput, setCouponInput] = useState(summary.couponCode ?? '');
  const [showRemovedMessage, setShowRemovedMessage] = useState(false);
  const [localCouponError, setLocalCouponError] = useState<string>('');
  const couponApplied = (summary.couponCode ?? '').trim().length > 0;

  // Limpa o input quando o cupom for removido
  useEffect(() => {
    if (!summary.couponCode) {
      setCouponInput('');
    } else {
      // Atualiza o input quando um cupom for aplicado (incluindo automático)
      setCouponInput(summary.couponCode);
    }
  }, [summary.couponCode]);

  // Limpa erro local quando cupom for aplicado com sucesso
  useEffect(() => {
    if (summary.couponCode && (summary.discountAmount ?? 0) > 0) {
      setLocalCouponError('');
    }
  }, [summary.couponCode, summary.discountAmount]);

  const handleApplyCoupon = async () => {
    if (onApplyCoupon) {
      try {
        setLocalCouponError(''); // Limpa erro anterior
        await onApplyCoupon(
          couponInput === summary.couponCode ? '' : couponInput.trim().toUpperCase()
        );
      } catch (error) {
        if (error instanceof Error) {
          setLocalCouponError(error.message);
        } else {
          setLocalCouponError('Erro ao aplicar cupom');
        }
      }
    }
  };

  const handleRemoveCoupon = () => {
    if (onApplyCoupon) {
      onApplyCoupon(''); // Passa string vazia para remover o cupom
      setShowRemovedMessage(true);
      setTimeout(() => setShowRemovedMessage(false), 3000); // Esconde a mensagem após 3 segundos
    }
  };

  return {
    couponInput,
    showRemovedMessage,
    localCouponError,
    couponApplied,
    handleApplyCoupon,
    handleRemoveCoupon,
    setCouponInput,
  };
}; 